"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useRef, useEffect, useCallback } from "react";
import { InlineMediaPanel } from "../../component/InlineMediaPanel/InlineMediaPanel";
import { useScreenSize } from "../../utils/hooks/useScreenSize";
import { ScrollChevron } from "../../component/ScrollChevron/ScrollChevron";
import "./LayoutInlineMedia.css";
interface InlineMediaTabViewProps {
  id?: string;
  panels: InlineMediaPanel[];
  componentImagePriority?: "high" | "auto" | "low";
  isLCP?: boolean;
}
export const InlineMediaTabView = t0 => {
  const $ = _c(29);
  const {
    id,
    panels,
    componentImagePriority,
    isLCP: t1
  } = t0;
  const isLCP = t1 === undefined ? false : t1;
  const {
    width
  } = useScreenSize();
  const [activeTab, setActiveTab] = useState(0);
  const tabListRef = useRef(null);
  const containerRef = useRef(null);
  const [showLeftScroll, setShowLeftScroll] = useState(false);
  const [showRightScroll, setShowRightScroll] = useState(false);
  const scrollRafRef = useRef(null);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      if (scrollRafRef.current !== null) {
        return;
      }
      scrollRafRef.current = requestAnimationFrame(() => {
        scrollRafRef.current = null;
        const el = tabListRef.current;
        if (!el) {
          return;
        }
        setShowRightScroll(el.scrollWidth > el.clientWidth && el.scrollLeft + el.clientWidth < el.scrollWidth - 5);
        setShowLeftScroll(el.scrollLeft > 0);
      });
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const scrollCheck = t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = direction => {
      tabListRef.current?.scrollBy({
        left: direction === "left" ? -100 : 100,
        behavior: "smooth"
      });
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const scrollTabList = t3;
  const handleKeyDown = (e, index) => {
    let next;
    if (e.key === "ArrowRight") {
      next = (index + 1) % panels.length;
    } else {
      if (e.key === "ArrowLeft") {
        next = (index - 1 + panels.length) % panels.length;
      } else {
        if (e.key === "Home") {
          next = 0;
        } else {
          if (e.key === "End") {
            next = panels.length - 1;
          } else {
            return;
          }
        }
      }
    }
    e.preventDefault();
    setActiveTab(next);
    const btn = containerRef.current?.querySelector(`[data-tab-index="${next}"]`);
    btn?.focus();
  };
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const el_0 = tabListRef.current;
      if (!el_0) {
        return;
      }
      scrollCheck();
      el_0.addEventListener("scroll", scrollCheck, {
        passive: true
      });
      const ro = new ResizeObserver(() => scrollCheck());
      ro.observe(el_0);
      return () => {
        el_0.removeEventListener("scroll", scrollCheck);
        ro.disconnect();
        if (scrollRafRef.current !== null) {
          cancelAnimationFrame(scrollRafRef.current);
          scrollRafRef.current = null;
        }
      };
    };
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== width) {
    t5 = [width, scrollCheck];
    $[3] = width;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  useEffect(t4, t5);
  const t6 = "relative w-full px-5 lg:px-0 overflow-hidden";
  let t7;
  if ($[5] !== showLeftScroll) {
    t7 = showLeftScroll && <button type="button" aria-label="Scroll tabs left" onClick={() => {
      scrollTabList("left");
      scrollCheck();
    }} className="absolute left-0 top-0 z-[3] h-[46px] w-[33px] flex items-center justify-center cursor-pointer p-0 border-0 border-l-2 text-blue-trmb t2-dark:text-white border-blue-trmb t2-dark:border-yellow-m10 t4:border-white bg-[linear-gradient(90deg,_#fff_80%,_transparent)] t2:bg-[linear-gradient(90deg,_#f1f1f6_80%,_transparent)] t3:bg-[linear-gradient(90deg,_#252a2e_80%,_transparent)] t4:bg-[linear-gradient(90deg,_#0063a3_80%,_transparent)] t5:bg-[linear-gradient(90deg,_#003054_80%,_transparent)] t7:bg-[linear-gradient(90deg,_#1b2023_80%,_transparent)]"><ScrollChevron direction="left" /></button>;
    $[5] = showLeftScroll;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== showRightScroll) {
    t8 = showRightScroll && <button type="button" aria-label="Scroll tabs right" onClick={() => {
      scrollTabList("right");
      scrollCheck();
    }} className="absolute right-0 top-0 z-[3] h-[46px] w-[33px] flex items-center justify-center cursor-pointer p-0 border-0 border-r-2 text-blue-trmb t2-dark:text-white border-blue-trmb t2-dark:border-yellow-m10 t4:border-white bg-[linear-gradient(270deg,_#fff_80%,_transparent)] t2:bg-[linear-gradient(270deg,_#f1f1f6_80%,_transparent)] t3:bg-[linear-gradient(270deg,_#252a2e_80%,_transparent)] t4:bg-[linear-gradient(270deg,_#0063a3_80%,_transparent)] t5:bg-[linear-gradient(270deg,_#003054_80%,_transparent)] t7:bg-[linear-gradient(270deg,_#1b2023_80%,_transparent)]"><ScrollChevron direction="right" /></button>;
    $[7] = showRightScroll;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const t9 = "tablist";
  const t10 = "Content panels";
  const t11 = "t2-lo-inline-media__tab-wrapper flex flex-nowrap overflow-x-auto overflow-y-hidden relative border-b border-gray-m3 mb-12 sm:mb-20 m-0";
  const t12 = panels.map((panel, index_0) => {
    const isActive = index_0 === activeTab;
    return <button key={`tab-${panel.id}-${index_0}`} role="tab" type="button" data-tab-index={index_0} id={`tab-${id}-${index_0}`} aria-selected={isActive} aria-controls={`tabpanel-${id}-${index_0}`} tabIndex={isActive ? 0 : -1} onClick={() => setActiveTab(index_0)} onKeyDown={e_0 => handleKeyDown(e_0, index_0)} className="bg-transparent border-0 p-0 rounded-none cursor-pointer"><h3 className={["t2-lo-inline-media-tab-title inline-flex flex-col whitespace-nowrap text-base leading-[1.375rem] tracking-[0.4px] !py-2.5 !px-5 sm:!px-[25px] uppercase m-0", "border-b-[4px]", isActive ? "font-bold text-blue-trmb border-blue-trmb shadow-sm t2-dark:text-yellow-m10 t2-dark:border-yellow-m10" : "font-normal text-gray-m9 border-transparent t2-dark:text-white"].join(" ")}>{panel.publicTitle}<span className="h-0 font-bold invisible overflow-hidden pointer-events-none select-none" aria-hidden="true">{panel.publicTitle}</span></h3></button>;
  });
  let t13;
  if ($[9] !== t12) {
    t13 = <div ref={tabListRef} role={t9} aria-label={t10} className={t11}>{t12}</div>;
    $[9] = t12;
    $[10] = t13;
  } else {
    t13 = $[10];
  }
  let t14;
  if ($[11] !== activeTab || $[12] !== componentImagePriority || $[13] !== id || $[14] !== isLCP || $[15] !== panels) {
    let t15;
    if ($[17] !== activeTab || $[18] !== componentImagePriority || $[19] !== id || $[20] !== isLCP) {
      t15 = (panel_0, index_1) => {
        const isActive_0 = index_1 === activeTab;
        return <div key={`tabpanel-${panel_0.id}-${index_1}`} role="tabpanel" id={`tabpanel-${id}-${index_1}`} aria-labelledby={`tab-${id}-${index_1}`} hidden={!isActive_0}><InlineMediaPanel {...panel_0} displayMode="tabs" componentImagePriority={componentImagePriority} isLCP={isLCP && index_1 === 0} isActiveSlide={isActive_0} /></div>;
      };
      $[17] = activeTab;
      $[18] = componentImagePriority;
      $[19] = id;
      $[20] = isLCP;
      $[21] = t15;
    } else {
      t15 = $[21];
    }
    t14 = panels.map(t15);
    $[11] = activeTab;
    $[12] = componentImagePriority;
    $[13] = id;
    $[14] = isLCP;
    $[15] = panels;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[22] !== containerRef || $[23] !== id || $[24] !== t13 || $[25] !== t14 || $[26] !== t7 || $[27] !== t8) {
    t15 = <div ref={containerRef} id={id} className={t6}>{t7}{t8}{t13}{t14}</div>;
    $[22] = containerRef;
    $[23] = id;
    $[24] = t13;
    $[25] = t14;
    $[26] = t7;
    $[27] = t8;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  return t15;
};